import qs from 'query-string';
import { getAxiosConfig, configAxios } from './apiConfig';
import { createLog } from './logService';
import { UPDATE_COURSE } from '../store/types/schoolDetailTypes';

export const fetchCourses = async (params, dispatch) => {
  try {
    const qsParams = qs.stringify(params);
    const response = await configAxios.get(`/Course?${qsParams}`);

    if (response.data.length === [].length) {
      dispatch({
        type: UPDATE_COURSE,
        payload: [],
      });

      return [];
    }

    dispatch({
      type: UPDATE_COURSE,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export async function getOnlineCourseSkills(req, res) {
  try {
    const config = await getAxiosConfig(req, res);

    const response = await config.get('admin/online-courses/skills');

    return response?.data;
  } catch (error) {
    return createLog(error);
  }
}
